import React from "react";
import { Gauge, Zap, Radio } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { images } from "../mock";

const newsIcons = [Gauge, Zap, Radio];

export default function News() {
  const { t } = useLanguage();
  const { ref, visible } = useReveal();

  return (
    <section id="novita" className="py-20 lg:py-28 bg-secondary/60">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <span className="text-primary font-semibold text-sm tracking-[0.18em] uppercase">
              {t.news.eyebrow}
            </span>
            <h2 className="mt-3 font-display font-extrabold text-slate-900 text-[30px] sm:text-[40px] leading-tight tracking-[-0.02em]">
              {t.news.title}
            </h2>
          </div>
        </div>

        <div ref={ref} className="mt-12 grid lg:grid-cols-3 gap-6">
          {t.news.items.map((item, i) => {
            const Icon = newsIcons[i];
            const imgs = [images.signalBars, images.freeWifiSign, images.antenna];
            return (
              <article
                key={i}
                className={`group bg-white rounded-2xl overflow-hidden border border-slate-100 hsc-card-shadow hover:-translate-y-1.5 transition-transform duration-300 hsc-reveal ${
                  visible ? "is-visible" : ""
                }`}
                style={{ animationDelay: `${i * 120}ms` }}
              >
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={imgs[i]}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wider bg-white/90 text-primary px-3 py-1.5 rounded-full">
                    <Icon className="w-3.5 h-3.5" /> {item.tag}
                  </span>
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-[18px] text-slate-900 leading-snug">{item.title}</h3>
                  <p className="mt-2.5 text-[14px] leading-relaxed text-slate-700">{item.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
